import { render } from "./MTableLayout.vue?vue&type=template&id=5824f88a&scoped=true"
import script from "./MTableLayout.vue?vue&type=script&lang=js"
export * from "./MTableLayout.vue?vue&type=script&lang=js"

import "./MTableLayout.vue?vue&type=style&index=0&id=5824f88a&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5824f88a"]])

export default __exports__